/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader"
import { MDXProvider } from "@mdx-js/react"
import { FaSquare } from "react-icons/fa"

import Callout from "./callout"
import Spoiler from "./spoiler"
import Header from "./header"
import CustomTooltip from "./tooltip"
import "./layout.css"
import "katex/dist/katex.min.css"

const Comp = (props) => {
  return (
    <>
      <h1>Hmm</h1>
      {props.children}
    </>
  )
}

const components = {
  Callout,
  Comp,
  Spoiler,
  FaSquare,
  CustomTooltip,
}

const Layout = ({ children }) => {
  deckDeckGoHighlightElement()
  return (
    <>
      <Header />
      <MDXProvider components={components}>
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0 1.0875rem 1.45rem`,
          }}
        >
          <main>{children}</main>
        </div>
      </MDXProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
